// Pied de page avec les liens légaux (politique de confidentialité, mentions légales, charte de contenu).
// Liens en <a> classiques : ce sont des pages statiques servies hors de la SPA (/privacy, /charte-contenu).

export const Footer = () => (
  <footer className="py-6 text-center text-xs text-neutral-400">
    <a
      href="/privacy"
      className="hover:text-neutral-600 hover:underline underline-offset-2"
    >
      Confidentialité &amp; mentions légales
    </a>
    <span className="mx-2">·</span>
    <a
      href="/charte-contenu"
      className="hover:text-neutral-600 hover:underline underline-offset-2"
    >
      Charte de contenu
    </a>
    <span className="mx-2">·</span>
    <a
      href="/suppression-donnees"
      className="hover:text-neutral-600 hover:underline underline-offset-2"
    >
      Suppression des données
    </a>
    <span className="mx-2">·</span>
    <a
      href="/conditions"
      className="hover:text-neutral-600 hover:underline underline-offset-2"
    >
      Conditions de service
    </a>
    <span className="mx-2">·</span>
    <span>© 2026 SpAIce Lab</span>
  </footer>
);
